export default function getFullDriverName(d) {
    return `${d.forename} ${d.surname}`;
}
